import {Sorting, SortingDirection} from "@/components/table/Table.types.ts";
import {RUMSection} from "@/pages/rum/v2/details/graphs/segments/SectionBtnGroup.tsx";
import {RUMChartTab} from "@/pages/rum/v2/details/graphs/types.ts";
import {ReportSpec} from "@/pages/rum/v2/details/ReportDefType.ts";

export const getSectionDef = (reportSpec: ReportSpec, section: RUMSection) => {
  return reportSpec.segments.sections[
    {
      [RUMSection.URL]: 0,
      [RUMSection.DEVICE]: 1,
      [RUMSection.PLATFORM]: 2,
      [RUMSection.BROWSER]: 3,
      [RUMSection.COUNTRY]: 4,
    }[section]
  ];
};

export const getDefaultSorting = (tab: RUMChartTab): Sorting => {
  switch (tab) {
    case RUMChartTab.PAGE_LOAD_TIME: {
      return {column: "PageViews", direction: SortingDirection.Desc};
    }
    case RUMChartTab.AJAX_LOAD_TIME: {
      return {column: "AjaxViews", direction: SortingDirection.Desc};
    }
    case RUMChartTab.ERRORS: {
      return {column: "Hits", direction: SortingDirection.Desc};
    }
    case RUMChartTab.BOUNCE_RATE: {
      return {column: "BounceRate", direction: SortingDirection.Desc};
    }
  }
};
